import styled, { createGlobalStyle } from 'styled-components';
import { FontCoolvetica } from "./fonts/coolveltica"
import { FontRaleway } from "./fonts/raleway"

export const GlobalStyle = createGlobalStyle`
  ${FontCoolvetica}
  ${FontRaleway}

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: 'Coolvetica', Arial, Helvetica, sans-serif;
    font-weight: 300;
  }
`;

export const Container = styled.div<{ isSmall?: boolean }>`
  width: 100%;
  max-width: 1212px;
  margin: auto;
  padding: 0 14px;

  ${({ isSmall }) => isSmall && `max-width: 980px`}
`;

export const Spacer = styled.hr`
  max-width: 592px;
  height: 8px;
  margin: 64px auto;
  border: none;
  background-color: ${({ theme }) => theme.colors.pink.light};
`;